<template>
  <v-navigation-drawer
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    temporary
    style="padding-bottom: var(--footer-height, 0px)"
  >
    <v-list nav density="compact">
      <v-list-item :to="{ name: 'accueil' }" exact prepend-icon="mdi-home" title="Accueil"></v-list-item>
      <v-list-item :to="{ name: 'rivieres' }" prepend-icon="mdi-map-search" title="Rivières"></v-list-item>
      <v-list-item :to="{ name: 'dangers' }" prepend-icon="mdi-alert-outline" title="Dangers"></v-list-item>
      <v-list-item :to="{ name: 'partenaires' }" prepend-icon="mdi-handshake" title="Partenaires"></v-list-item>
      <v-list-item :to="{ name: 'a-propos' }" prepend-icon="mdi-information-outline" title="À propos"></v-list-item>
    </v-list>
    <small class="text-center d-block mt-2 mb-2">Version {{ appVersion }}</small>
  </v-navigation-drawer>
</template>

<script>
  export default {
    name: "MainNavigationDrawer",
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      appVersion: {
        type: String,
        default: "",
      },
    },
    emits: ["update:modelValue"],
  };
</script>
